import styled, { css } from 'styled-components';
import { getToken } from '@optimus-web/common';
import { Stack, StackProps } from '@optimus-web/core';

export const ExtendedTextInputContainer = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
`;

export const SearchInput = styled.input<{ focused: boolean; isMql: boolean }>`
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
    background-color: transparent;
    outline: none;
    border: none;
    font-weight: 400;

    ::placeholder {
        opacity: 0.75;
    }

    &:hover {
        color: ${getToken('textStaticPrimary')};
        ${(props) =>
            props.isMql &&
            css`
                color: ${getToken('textStaticTertiary')};
            `}
    }

    ${(props) =>
        props.focused &&
        css`
            color: ${getToken('textStaticPrimary')};
        `}

    ${(props) =>
        props.focused &&
        props.isMql &&
        css`
            color: ${getToken('textStaticTertiary')};
        `}
`;

export const FirstSuggestion = styled.div`
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;
    color: ${getToken('textStaticTertiary')};
    opacity: 0.5;
    pointer-events: none;
    align-content: center;
    padding-block: 1px;
    padding-inline: 2px;
    line-height: normal;
`;

export const Overlay = styled.div`
    position: absolute;
    z-index: 50;
    height: 100%;
    width: 100%;
    pointer-events: none;
    align-content: center;
    padding-block: 1px;
    padding-inline: 2px;
    line-height: normal;
    color: ${getToken('textStaticPrimary')};
`;

export const TextLengthStack = styled<React.ComponentType<StackProps>>(Stack)`
    position: absolute;
    top: 21px;
`;
